import { render, staticRenderFns } from "./PAddressV2.vue?vue&type=template&id=c4d07536&scoped=true&"
import script from "./PAddressV2.vue?vue&type=script&lang=js&"
export * from "./PAddressV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d07536",
  null
  
)

export default component.exports